import { Outlet } from "react-router-dom";
import { HeaderGNB } from "../../organisms";

export const AlwaysHeaderRequiredTemplate = () => (
  <>
    <HeaderGNB isLoginPage={false} />
    <Outlet />
  </>
);
